// Transient HUD notice (2026-10-21): a small LCARS-coloured box just under the top bar showing why the
// server refused an order. ONE node in game.gui (camera child in 2D, rig child in XR), so desktop, phone and
// XR share it. Shown ~4 s, a tap on it dismisses. It stays visible while the HUD is hidden (phones start
// hidden): hud-toggle.js applyHidden skips nodes with userData.hudNotice.
import { box } from 'imperial-lib';
import { ensureLcarsFont } from './box-patcher.js';

const SHOW_MS = 4000;
let timer = null;

export function hideHudNotice(game) {
	clearTimeout(timer);
	timer = null;
	const n = game.hudNotice;
	if (n) { n.visible = false; n.userData.shown = false; }
}

export async function showHudNotice(game, text) {
	const font = await ensureLcarsFont();
	hideHudNotice(game);
	if (game.hudNotice) { game.hudNotice.dispose?.(); game.hudNotice.parent?.remove(game.hudNotice); }
	const vp = globalThis.__guiViewport;
	const W = (vp && vp.width) || window.innerWidth, H = (vp && vp.height) || window.innerHeight;
	const width = Math.min(520, W - 60), height = 40;
	const n = box({ width, height, text, font, fontSize: 18, color: [1, 1, 1], textAlign: 'center', vAlign: 'middle',
		padding: [0, 10, 0, 10], borderRadii: [18, 18, 18, 18], backgroundColor: [0.5, 0, 0, 0.95],
		clickable: true, onClick: () => hideHudNotice(game) });
	n.userData.hudNotice = true;
	n.userData.layoutIgnore = true;
	n.userData.rayOpaque = true;
	// just below the frame's top bar (20 px margin + ~34 px bar), centred
	n.position.set(0, H / 2 - 20 - 34 - 8 - height / 2, 2);
	n.renderOrder = (game.gui.renderOrder || 10000) + 300;
	n.traverse((o) => { if (o.material) { o.material.depthTest = false; o.renderOrder = n.renderOrder + (o.material.uniforms?.atlas ? 2 : 1); } });
	game.gui.add(n);
	game.hudNotice = n;
	n.userData.shown = true;
	timer = setTimeout(() => hideHudNotice(game), SHOW_MS);
}

export function refusalText(response) {
	if (!response?.error) return null;
	if (response.error === 'NOT LOGGED IN') return 'NOT LOGGED IN — log in to command units';
	if (response.error === 'NOT YOUR UNITS') return 'NOT YOUR UNITS';
	return String(response.error);
}
